'use client';

import React, { useState } from 'react';
import { ClipboardDocumentIcon, CheckIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';

interface ProfileClipboardCopyProps {
  address?: string | undefined;
  ensName?: string;
  profileName?: string;
  isClipboardEnabled?: boolean;
}

const ClipboardCopyWithHiddenAddress: React.FC<ProfileClipboardCopyProps> = ({
  address,
  ensName,
  profileName,
  isClipboardEnabled = true,
}) => {
  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopy = async (event: any) => {
    event.stopPropagation();
    if (address) {
      try {
        await navigator.clipboard.writeText(address);
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 3000);
      } catch (err) {
        setCopySuccess(false);
        console.error('Failed to copy: ', err);
      }
    }
  };

  return (
    <div className="flex relative items-center justify-center max-w-max min-w-[30px]">
      {(ensName || profileName) && (
        <Link
          href={`/karratco/view/profile/${address}`}
          title={address}
          className="text-sm"
        >
          {ensName ? ensName : profileName}
        </Link>
      )}
      {isClipboardEnabled && (
        <button
          type="button"
          className="inline-block w-4 h-4"
          onClick={handleCopy}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
          }}
        >
          {copySuccess ? (
            <CheckIcon className="w-4 h-4 ml-1 text-accent" />
          ) : (
            <ClipboardDocumentIcon className="w-4 h-4 ml-1 cursor-pointer text-yellow" />
          )}
        </button>
      )}
    </div>
  );
};

export default ClipboardCopyWithHiddenAddress;
